import React from 'react';
import { Button } from 'reactstrap';
import _404Image from '../assets/404/404.png';
import { useNavigate } from 'react-router-dom';
import { useDict } from '../contexts/LanguageContext';
import ROUTE_NAME from '../routes/RouteName';

const PageNotFound = () => {
    const dict = useDict();

    const navigate = useNavigate();

    const handleClick = () => {
        navigate(ROUTE_NAME.INVEST_NOW);
    };

    return (
        <div className="not-found">
            <div className="not-found__content">
                <img className="not-found__image" src={_404Image} alt="404" />
                <h3 className="not-found__info">{dict.notFoundInfo}</h3>
                <Button color="primary" onClick={handleClick}>
                    {dict.backHome}
                </Button>
            </div>
        </div>
    );
};

export default PageNotFound;
